import React from 'react';
import { TbExternalLink, TbExternalLinkOff } from 'react-icons/tb';
import { Link } from 'react-router-dom';

export interface Props {
  buttonLogo: string;
  href?: string | null | undefined;
  buttonName: string;
}

export const DeliveryLinkButton: React.FC<Props> = ({ buttonLogo, href, buttonName }: Props) => {
  return (
    <>
      {href ? (
        <Link target="_blank" to={href} className="flex h-full w-fit">
          <div className="bg-gray-500 w-12 min-h-10 rounded-l-lg">
            <img draggable={false} src={buttonLogo} alt={buttonName} width={50} height={50} className="rounded-l-lg h-full w-full object-cover" />
          </div>

          <div className="rounded-r-lg self-center text-gray-700 h-full flex items-center  py-1 px-1 text-2xl border-y border-r hover:bg-gray-50 hover:cursor-pointer">
            <TbExternalLink size={20} />
          </div>
        </Link>
      ) : (
        <div className="grayscale opacity-70 border border-gray-500 border-dashed rounded-l-lg rounded-r-lg flex h-full w-fit">
          <div className="bg-gray-500 w-12 min-h-10 rounded-l-lg">
            <img draggable={false} src={buttonLogo} alt={buttonName} width={50} height={50} className="rounded-l-lg h-full w-full object-cover" />
          </div>

          <div className="rounded-r-lg self-center text-gray-700 h-full  bg-gray-300 flex items-center  py-1 px-1 text-2xl border-y border-r">
            <TbExternalLinkOff size={20} />
          </div>
        </div>
      )}
    </>
  );
};
